export default __webpack_public_path__ + "images/I2.f2819cf.png";